module.exports = __webpack_public_path__ + "static/media/news50.2459be31.jpg";